import { createAsyncThunk } from '@reduxjs/toolkit';
import PropertiesResource from 'api/service/PropertiesResource';
import FilesServiceResource from 'api/service/FilesResource';

export const createProperty = createAsyncThunk(
  'properties/createProperty',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { property, parent } = initialData;
    const params = { includes: 'user' };

    const { status, data } = await propertiesResource.create(property, params);
    if (status === 201) {
      return { parent, property: { ...data, fileType: 'Folder', entity: 'Property' } };
    }
    return rejectWithValue('Property creation failed.');
  }
);

export const updateProperty = createAsyncThunk(
  'properties/updateProperty',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { id, property, origin } = initialData;
    const { status, data } = await propertiesResource.property(id).update(property);
    if (status === 200) {
      return { ...data, fileType: 'Folder', entity: 'Property', origin };
    }
    return rejectWithValue('Property update failed.');
  }
);

export const deleteProperty = createAsyncThunk(
  'properties/deleteProperty',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { id } = initialData;
    const { status } = await propertiesResource.property(id).delete();
    if (status === 202) {
      return id;
    }
    return rejectWithValue('Property delete failed.');
  }
);

export const getProperyFileDetails = createAsyncThunk('properties/getProperyFileDetails', async (initialData) => {
  const filesResource = new FilesServiceResource();
  const oid = initialData;
  const { status, data } = await filesResource.getByOid(oid);
  if (status === 200) {
    return data;
  }
  return null;
});

export const getProperty = createAsyncThunk('properties/getProperty', async (initialData) => {
  const propertiesResource = new PropertiesResource();
  const { id } = initialData;
  const params = { includes: 'user' };

  const { status, data } = await propertiesResource.property(id).get(params);
  if (status === 200) {
    return data;
  }
  return null;
});

export const getPropertyPreview = createAsyncThunk(
  'properties/getPropertyPreview',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { id } = initialData;
    const { data, status } = await propertiesResource.preview(id).get();
    if (status === 200) {
      // convert response data blob to image url
      const imageUrl = URL.createObjectURL(data);
      return imageUrl;
    }
    return rejectWithValue('Property preview photo not found.');
  }
);

export const setFileAsPropertyPhoto = createAsyncThunk(
  'properties/setFileAsPropertyPhoto',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { parent, id } = initialData;
    const { status } = await propertiesResource.preview(parent).set(id);
    if (status === 200) {
      return { parent, id };
    }
    return rejectWithValue('Photo as property photo failed');
  }
);

export const removePropertyPhoto = createAsyncThunk(
  'properties/removePropertyPhoto',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { id } = initialData;
    const { status } = await propertiesResource.preview(id).remove();
    if (status === 202) {
      return status;
    }
    return rejectWithValue('Removing property photo failed');
  }
);

export const readProperty = createAsyncThunk('properties/readProperty', async (initialData, { rejectWithValue }) => {
  const { id } = initialData;

  const propertiesResource = new PropertiesResource();
  const { status, data } = await propertiesResource.property(id).get();
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Property get failed');
});
